import React, { useState } from 'react';
import { api } from './api/api';

const Test = () => {
    const [data, setData] = useState(null);

    const fetchData = async () => {
        try {
            const response = await api.get('/test');
            setData(response.data);
        } catch (error) {
            console.error('Test request error', error);
        }
    };

    return (
        <div>
            <button onClick={fetchData}>Make Test Request</button>
            {data && <pre>{JSON.stringify(data, null, 2)}</pre>}
        </div>
    );
};

export default Test;